module.exports = __webpack_public_path__ + "static/media/18ECA28.8f6d0e9a.jpg";